import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OEDemoTargetType = {
    anatomy:        'anatomy',
    histology:      'histology',
    ophthalmology:  'ophthalmology',
    orthopedic:     'orthopedic',
    toxicology:     'toxicology',
    visceral:       'visceral'
    // cell:           'cell'
};

OEDemoTargetType.all = [
    OEDemoTargetType.anatomy,
    OEDemoTargetType.histology,
    OEDemoTargetType.ophthalmology,
    OEDemoTargetType.orthopedic,
    OEDemoTargetType.toxicology,
    OEDemoTargetType.visceral
    // OEDemoTargetType.cell
];

export const OEDemoStartSelectionContent = {
    [OEDemoTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanForearmDemo
                    ]
                }
            ]
        }
    ],
    [OEDemoTargetType.histology]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanLiverMicro
                    ]
                }
            ]
        }
    ],
    [OEDemoTargetType.ophthalmology]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryEyeCataract
                    ]
                }
            ]
        }
    ],      
    [OEDemoTargetType.orthopedic]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.implantcastEcoFitHipStem,
                        OETargetMenuDefs.surgeryIdo,
                        OETargetMenuDefs.surgeryLinkEmbrace
                    ]
                }
            ]
        }
    ],
    [OEDemoTargetType.toxicology]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEyeCornea,
                    ]
                }
            ]
        }
    ],    
    [OEDemoTargetType.visceral]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryAppendix,
                    ]
                }
            ]
        }
    ],
    // [OEDemoTargetType.cell]: [
    //     {
    //         subcategories: [
    //             {
    //                 items: [
    //                     OETargetMenuDefs.humanBrainPotential
    //                 ]
    //             }
    //         ]
    //     }
    // ],

    [OEDemoTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanForearmDemo
                    ]
                }
            ]
        }
    ],
    [OEDemoTargetType.histology + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanLiverMicro
                    ]
                }
            ]
        }
    ],
    [OEDemoTargetType.ophthalmology + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryEyeCataract
                    ]
                }
            ]
        }
    ],        
    [OEDemoTargetType.orthopedic + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.implantcastEcoFitHipStem,
                        OETargetMenuDefs.surgeryIdo,
                        OETargetMenuDefs.surgeryLinkEmbrace
                    ]
                }
            ]
        }
    ],
    // [OEDemoTargetType.cell + OEAlphaBetaProdTypes.beta]: [
    //     {
    //         subcategories: [
    //             {
    //                 items: [
    //                     OETargetMenuDefs.humanBrainPotential
    //                 ]
    //             }
    //         ]
    //     }
    // ],

    [OEDemoTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanForearmDemo
                    ]
                }
            ]
        }
    ],
    [OEDemoTargetType.histology + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanLiverMicro
                    ]
                }
            ]
        }
    ],
    [OEDemoTargetType.ophthalmology + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryEyeCataract
                    ]
                }
            ]
        }
    ],         
    [OEDemoTargetType.orthopedic + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.implantcastEcoFitHipStem,
                        OETargetMenuDefs.surgeryIdo,
                    ]
                }
            ]
        }
    ],
    // [OEDemoTargetType.cell + OEAlphaBetaProdTypes.prod]: [
    //     {
    //         subcategories: [
    //             {
    //                 items: [
    //                     OETargetMenuDefs.humanBrainPotential
    //                 ]
    //             }
    //         ]
    //     }
    // ]
};

OEDemoStartSelectionContent.modules = [
    {id: OEDemoTargetType.anatomy, icon: OEIconCodes.demo.anatomyTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.anatomy]},
    {id: OEDemoTargetType.histology, icon: OEIconCodes.demo.histologyTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.histology]},
    {id: OEDemoTargetType.ophthalmology, icon: OEIconCodes.demo.ophthalmologyTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.ophthalmology]},
    {id: OEDemoTargetType.orthopedic, icon: OEIconCodes.demo.orthopedicTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.orthopedic]},
    {id: OEDemoTargetType.toxicology, icon: OEIconCodes.demo.toxicologyTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.toxicology]},
    {id: OEDemoTargetType.visceral, icon: OEIconCodes.demo.visceralTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.visceral]},    
    // {id: OEDemoTargetType.cell, icon: OEIconCodes.demo.cellTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.cell]}
];

OEDemoStartSelectionContent.modulesBeta = [
    {id: OEDemoTargetType.anatomy, icon: OEIconCodes.demo.anatomyTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.anatomy + OEAlphaBetaProdTypes.beta]},
    {id: OEDemoTargetType.histology, icon: OEIconCodes.demo.histologyTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.histology + OEAlphaBetaProdTypes.beta]},
    {id: OEDemoTargetType.ophthalmology, icon: OEIconCodes.demo.ophthalmologyTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.ophthalmology + OEAlphaBetaProdTypes.beta]},
    {id: OEDemoTargetType.orthopedic, icon: OEIconCodes.demo.orthopedicTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.orthopedic + OEAlphaBetaProdTypes.beta]},
    // {id: OEDemoTargetType.cell, icon: OEIconCodes.demo.cellTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.cell + OEAlphaBetaProdTypes.beta]}
];

OEDemoStartSelectionContent.modulesProduction = [
    {id: OEDemoTargetType.anatomy, icon: OEIconCodes.demo.anatomyTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.anatomy + OEAlphaBetaProdTypes.prod]},
    {id: OEDemoTargetType.histology, icon: OEIconCodes.demo.histologyTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.histology + OEAlphaBetaProdTypes.prod]},
    {id: OEDemoTargetType.ophthalmology, icon: OEIconCodes.demo.ophthalmologyTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.ophthalmology + OEAlphaBetaProdTypes.prod]},
    {id: OEDemoTargetType.orthopedic, icon: OEIconCodes.demo.orthopedicTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.orthopedic + OEAlphaBetaProdTypes.prod]},
    // {id: OEDemoTargetType.cell, icon: OEIconCodes.demo.cellTarget, categories: OEDemoStartSelectionContent[OEDemoTargetType.cell + OEAlphaBetaProdTypes.prod]}
];